export const API_KEY = "AIzaSyDDbVdjUKf4B1bs_mt2TYI1iG4VXWF9bWg";

export default API_KEY;
